// extracted by mini-css-extract-plugin
module.exports = {"wrap":"VerificationCode_wrap__82fuL","button":"VerificationCode_button__undBj","errorText":"VerificationCode_errorText__m9B7Y"};